import { render, staticRenderFns } from "./ModelVulkanDJ.vue?vue&type=template&id=41c27d70&scoped=true"
import script from "./ModelVulkanDJ.vue?vue&type=script&lang=js"
export * from "./ModelVulkanDJ.vue?vue&type=script&lang=js"
import style0 from "./ModelVulkanDJ.vue?vue&type=style&index=0&id=41c27d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c27d70",
  null
  
)

export default component.exports